import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/var/www/joy-awards-frontend/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/joy-awards-frontend/src/components/home/categories/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/joy-awards-frontend/src/components/home/hero/CoverImage.tsx");
;
import(/* webpackMode: "eager" */ "/var/www/joy-awards-frontend/src/components/home/hero/index.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/joy-awards-frontend/src/components/home/lavender-carpet/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/joy-awards-frontend/src/components/home/performances/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/joy-awards-frontend/src/components/home/personality_of_the_year/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/joy-awards-frontend/src/components/home/wall_of_fame/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/joy-awards-frontend/src/components/shared/link/index.tsx");
;
import(/* webpackMode: "eager" */ "/var/www/joy-awards-frontend/src/components/ui/animations/fade.tsx");
;
import(/* webpackMode: "eager" */ "/var/www/joy-awards-frontend/src/components/ui/animations/reveal.tsx");
;
import(/* webpackMode: "eager" */ "/var/www/joy-awards-frontend/src/components/ui/animations/zoom.tsx");
